import React from 'react';
import clsx from 'clsx';

interface SurfaceProps extends React.HTMLAttributes<HTMLDivElement> {
  padding?: 'none' | 'sm' | 'md' | 'lg';
}

const paddingClasses = {
  none: '',
  sm: 'p-4',
  md: 'p-5',
  lg: 'p-6',
};

const Surface: React.FC<SurfaceProps> = ({
  className,
  padding = 'md',
  children,
  ...props
}) => (
  <div
    className={clsx(
      'rounded-lg border border-secondary-200 bg-white shadow-surface',
      'dark:border-secondary-800 dark:bg-secondary-900',
      paddingClasses[padding],
      className
    )}
    {...props}
  >
    {children}
  </div>
);

export default Surface;
